/*
Documentation

This page shows all of the deleted system courts

*/

import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import _location_courts from '_functions/location_courts';
import Circle from 'components/markup/loading/Circle'

import _archives from '_functions/archives';

const { SearchBar } = Search;

class ArchiveCourts extends React.Component {

    state = {
        location_courts: null
    }

    restore = async (court_id) => {

        const restored = await _archives.restore.court({court_id})

        if(restored.success) {

            let location_courts = [...this.state.location_courts];
            location_courts = location_courts.filter(u => u._id !== court_id)

            this.setState({location_courts})

        }

    }

    columns = [
        {
            dataField: "name",
            text: "Name",
        },
        {
            dataField: "county",
            text: "County",
        },
        {
            dataField: "phone",
            text: "Phone",
        },
        {
            dataField: "email",
            text: "Email",
        },

        {
            dataField: "address_line_1",
            text: "Address",
            formatter: (cell, row) => (
                <span>
                    {row.address_line_1}  {row.address_line_2} <br />
                    {row.city}, {row.state} {row.postal_code} {row.country}
                </span>
            )
        },

        {
            dataField: "_id",
            text: "Actions",
            headerStyle: {textAlign: 'right'},
            formatter: (cell, row) => {
                return (
                    <div className="text-right">
                        <button className="btn btn-outline-warning" onClick={() => this.restore(row._id)}>
                            <i className="fas fa-check mr-2" /> Restore Court
                        </button>
                    </div>
                )
            }
        },
    ]

    pagination = paginationFactory({
        page: 1,
        alwaysShowAllBtns: true,
        showTotal: true,
        withFirstAndLast: false,

        sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
            <div className="dataTables_length" id="datatable-basic_length">
                <label>
                    Show{" "}
                    {
                    <select
                        name="datatable-basic_length"
                        aria-controls="datatable-basic"
                        className="form-control form-control-sm"
                        onChange={e => onSizePerPageChange(e.target.value)}
                    >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    }{" "}
                    entries.
                </label>
            </div>
        )
    });

    componentDidMount = async () => {

        const location_courts = await _location_courts.find(`?filter=deleted__true{bool}&limit=500&sort=given_name__asc|family_name__asc`)

        if(location_courts.success) this.setState({location_courts: location_courts.data})

        this.setState({loaded: true})

    }

    render() {

        const { location_courts, loaded } = this.state

        if(!loaded) return <div className="py-4"><Circle /></div>

        return (

            <Card className="card-color card-success">

                <CardHeader>
                    <CardTitle className="mb-0 float-left">Deleted Courts</CardTitle>
                </CardHeader>

                {location_courts && location_courts.length ? (

                    <ToolkitProvider
                        data={location_courts}
                        keyField="_id"
                        columns={this.columns}
                        search
                    >
                        {props => (
                            <>
                            <div
                                id="datatable-basic_filter"
                                className="dataTables_filter px-4 pb pt-3 pb-2"
                                style={{width: '100%'}}
                            >
                                <label>
                                    Search:
                                    <SearchBar
                                        className="form-control-sm"
                                        placeholder="Template Name"
                                        {...props.searchProps}
                                    />
                                </label>
                            </div>
                            <div className=" table-responsive table-vertical-align table-not-fixed">
                                <BootstrapTable
                                    pagination={this.pagination}
                                    {...props.baseProps}
                                    bootstrap4={true}
                                    bordered={false}
                                />
                            </div>

                            </>

                        )}
                    </ToolkitProvider>

                ) : (

                    <CardBody>
                        <p className="text-sm mb-0">There are no deleted courts within the system.</p>
                    </CardBody>

                )}

            </Card>

        );
    }
}

export default ArchiveCourts

